<script setup lang="ts">
import { eventBus } from "#bb/lib/eventBus";

const props = defineProps<{ id: string }>();

const { getContentById } = useContentManager();
const definitionData = computed(() => getContentById(props.id));

const features = inject("render-features", { editor: false });

const commands = [
  {
    id: "editors-group",
    type: "group",
    name: "Editors",
    description: "Page Break editors",
    commands: [
      {
        id: "edit",
        name: "Edit",
        description: "Edit this page break",
        action: async () => {
          eventBus.emit(`component:onEdit:${props.id}`, {
            data: definitionData.value,
          });
        },
        icon: "lucide:edit",
      },
    ],
  },
];

defineExpose({
  commands,
  properties: {
    id: props.id,
    name: "Page Break",
    icon: "lucide:scissors-line-dashed",
  },
});
</script>

<template>
  <div
    v-if="features.editor"
    class="inline-flex items-center gap-2 rounded-sm border border-dashed bg-muted/30 px-3 py-2 text-xs text-muted-foreground"
  >
    <Icon mode="svg" size="14" name="lucide:scissors-line-dashed" />
    Page Break (rendered in PDF export)
  </div>

  <div v-if="features.editor" class="hidden">
    <editor-reports-page-break :id="props.id" />
  </div>
</template>

<script lang="ts">
import { ComponentDefinitionIds } from "#bb/lib/componentDefinitionIds";

export default {
  componentId: ComponentDefinitionIds.PAGE_BREAK,
  icon: "lucide:scissors-line-dashed",
  editor: () => import("#bb/components/editor/reports/page-break.vue"),
  type: "Page Break",
  description: "Inserts a PDF report page break rendered by the export compiler.",
  default: {},
  categories: ["Reports"],
  order: 12014,
};
</script>
